module.exports = __webpack_public_path__ + "static/media/danRed.4917de47.svg";